import React, { useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { UserType, UserTypeTab } from 'types'
import { buildSignInPathWithRedirect, getRoute } from 'utils'
import { useAuthContext } from '../components/context/AuthProvider'
import { routes } from '../routes/routes'

export const useCheckAuthorizationAndRedirect = (types: UserType[]): React.ReactNode => {
  const { user, checkIsLoggedIn } = useAuthContext()
  const location = useLocation()

  return useMemo(() => {
    if (!user || !checkIsLoggedIn()) {
      return (
        <Navigate
          to={buildSignInPathWithRedirect(location.pathname, location.search, location.hash)}
          replace
        />
      )
    }
    if (!types.some((it) => user.type.some((t) => t === it))) {
      switch (user.type[0]) {
        case UserType.ADMIN:
        case UserType.ANALYST:
          return <Navigate to={getRoute(routes.users, { userType: UserTypeTab.TRAINEE })} replace />
        case UserType.CARETEAM:
        case UserType.CAREGIVER:
        case UserType.TRAINEE:
          return <Navigate to={routes.journey} replace />
        case UserType.ORG_SUPERVISOR:
        case UserType.ORG_OWNER:
        case UserType.ORG_FACILITY_MANAGER:
        case UserType.ORG_REGIONAL_MANAGER:
          return (
            <Navigate to={getRoute(routes.orgUsers, { userType: UserTypeTab.TRAINEE })} replace />
          )
      }
    }
    return null
  }, [user, checkIsLoggedIn, location.pathname, location.search, location.hash, types])
}
